document.addEventListener("DOMContentLoaded", function() {
    var productpage = document.getElementById("#product-detailed-page");
    if(productpage){
        document.querySelectorAll('#product-detailed-page .product__media-wrapper img')[0].loading='eager';
        document.querySelectorAll('#product-detailed-page .thumbnail-slider img')[0].loading='eager';
    }
  
    if (window.innerWidth <= 249) {
        var element = document.getElementById("Details-menu-drawer-menu-item-1");
        if (element) { 
            element.removeAttribute("class");
            element.removeAttribute("open");
        }
    }
});

document.addEventListener('DOMContentLoaded', function() {
  var detailsElement = document.getElementById('Details-menu-drawer-container');

  if (detailsElement) {
    // Add classes
    detailsElement.classList.add('menu-drawer-container', 'menu-opening');

    // Function to handle minimum width
    function updateMinWidth() {
      if (window.innerWidth >= 1200) {
     
        detailsElement.setAttribute('open', '');
      } else { 
        detailsElement.removeAttribute('open'); // Optionally close the details element if below 992px
      }
    }

    // Initial check
    updateMinWidth();

    // Handle resizing
    window.addEventListener('resize', updateMinWidth);
  }
});

document.addEventListener('DOMContentLoaded', () => {
    const menuList = document.querySelector('ul.menu-drawer__menu.has-submenu.list-menu');
    const firstMenuItem = menuList.querySelector('li:first-child');
    firstMenuItem.addEventListener('mouseover', () => {
        firstMenuItem.classList.add('persistent-border');
    });
});

document.addEventListener("DOMContentLoaded", function() {   
  const searchInput = document.getElementById("Search-In-Modal");
  const searchLabel = document.querySelector("label[for='Search-In-Modal']");
  searchInput.addEventListener("focus", function() {
    searchLabel.classList.add("hidden");
  });
  searchInput.addEventListener("blur", function() {
    if (!searchInput.value) { // Only show the label if the input is empty
      searchLabel.classList.remove("hidden");
    }
  });
  const searchInputForm = document.getElementById("Search-In-Template");
  const searchLabelForm = document.querySelector("label[for='Search-In-Template']");
  if( searchInputForm ){
    const searchtext = searchInputForm.value;    
    if( searchtext != '' ){
        searchLabelForm.classList.add("hidden");
    }       
    searchInputForm.addEventListener("focus", function() {
      searchLabelForm.classList.add("hidden");
    });
    searchInputForm.addEventListener("blur", function() {
      if (!searchInputForm.value) { // Only show the label if the input is empty
        searchLabelForm.classList.remove("hidden");
      }
    });
  }   
});


// hide lable
document.addEventListener("DOMContentLoaded", function() {
  const inputField = document.querySelector(".footer-block__newsletter input");
  const label = document.querySelector("label[for='footer-block__newsletter input']");

  inputField.addEventListener("focus", function() {
    label.classList.add("hidden");
  });

  inputField.addEventListener("blur", function() {
    if (!inputField.value) { // Only show the label if the input is empty
      label.classList.remove("hidden");
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
    const summaryElement = document.querySelector('summary.menu-drawer__menu-item.listingssec.list-menu__item.link.link--text.focus-inset');
    const allMenuItems = document.querySelectorAll('li > a.menu-drawer__menu-item.link.link--text.list-menu__item.focus-inset');
    const submenuElement = document.querySelector('.menu-drawer__inner-submenu');
    // Helper function to add hover class
    function addHoverClass() {
        summaryElement.classList.add('hover');
    }
    // Helper function to remove hover class
    function removeHoverClass() {
        summaryElement.classList.remove('hover');
    }
    // Add hover class when hovering over the summary
    summaryElement.addEventListener('mouseenter', addHoverClass);
    // Remove hover class when leaving the summary but only if not hovering over the submenu
    summaryElement.addEventListener('mouseleave', function () {
        if (!submenuElement.matches(':hover')) {
            removeHoverClass();
        }
    });
    // Add hover class when hovering over the submenu
    submenuElement.addEventListener('mouseenter', addHoverClass);
    // Remove hover class when leaving the submenu and the summary
    submenuElement.addEventListener('mouseleave', function () {
        if (!summaryElement.matches(':hover')) {
            removeHoverClass();
        }
    });
    // Handle hover state for other menu items
    allMenuItems.forEach(item => {
        item.addEventListener('mouseover', function () {
            allMenuItems.forEach(el => el.classList.remove('current')); // Remove 'current' from all items
            item.classList.add('current');
        });

        item.addEventListener('mouseleave', function () {
            item.classList.remove('current');
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const summary = document.querySelector('.menu-drawer__menu-item[role="button"]');
    function updateSummaryClickState() {
      if (window.innerWidth >= 249) { // Adjust the width threshold as needed for desktop
        summary.addEventListener('click', preventClick);
      } else {
        summary.removeEventListener('click', preventClick);
      }
    }
    function preventClick(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    // Initial check
    updateSummaryClickState();
    // Update on window resize
    window.addEventListener('resize', updateSummaryClickState);
});

document.addEventListener('DOMContentLoaded', function() {
    const tabItems = document.querySelectorAll('.fn-customise-gallery .tab-item');
    const tabPanes = document.querySelectorAll('.fn-customise-gallery .tab-pane');
    tabItems.forEach(item => {
        item.addEventListener('click', function() {
            const targetTab = this.getAttribute('data-tab');
            // Remove active class from all tab items and panes
            tabItems.forEach(tab => tab.classList.remove('active'));
            tabPanes.forEach(pane => pane.classList.remove('active'));
            // Add active class to clicked tab item and corresponding pane
            this.classList.add('active');
            document.getElementById(targetTab).classList.add('active');
        });
    });
});


// anouncement lable
document.addEventListener("DOMContentLoaded", function() {
    // Select the first .innernav-li element
    const firstInnerNavLi = document.querySelector('.innernav-li');
    // Check if any .innernav-li contains an active link
    const hasActiveLink = document.querySelector('.innernav-li a.active');
    // If there's an active link, add the active class to the first .innernav-li
    if (hasActiveLink && firstInnerNavLi) {
        firstInnerNavLi.classList.add('selected');
    }
});

/* Product filters trigger */
$(document).ready(function() {
    $('.mobile-facets__open').click(function(){
        $('.mobile-facets__arrow.no-js-hidden').click();
    });  

    var gettext = $.trim($('.our-story p.image-with-text__text').text());
    var words = gettext.split(' ');

    /* product description break */
    var productdescription = $('#product-detailed-page .product__description').html();
    if(productdescription){
      var displayTest = '';
      var restText = '';
      var descriptionLength = jQuery("#product-detailed-page .product__description").html().length;  
      if ( productdescription.length > 800) {
            productdescription = productdescription.replace(/&nbsp;/g," ");
            displayTest = productdescription.substr(0,651);
            //console.log(displayTest);
            blurText = productdescription.substr(651,50);
            blurText = blurText.replace('</span>',"");
            blurText = blurText.replace('</p>',"");
            blurText = blurText.replace('<p>',"");        
            blurText = blurText.replace('<p class="p1">',"");
            blurText = blurText.replace('<span>',"");
            //console.log(blurText);
            restText = productdescription.substr(701, descriptionLength);
            //console.log(restText);
        
            $("#product-detailed-page .product__description").html('');
            $("#product-detailed-page .product__description").html('<p class="show-description">'+displayTest+'<span class="blurText">'+blurText+'</span><span id="dots">..</span><div id="more">'+restText+'</div></p>');

      }else{
            $('.read-more-partition').css('display','none');
            $('.product__info-container hr').css('display','none');
      }  
      
      /* Read more description button show hide */
      $('#btn-read-more').click(function() {
          var dots = document.getElementById("dots");
          var moreText = document.getElementById("more");
          var btnText = document.getElementById("btn-read-more");
        
          if (dots.style.display === "none") {
              dots.style.display = "inline";
              btnText.innerHTML = "Read more";
              moreText.style.display = "none";
              $('#more + p').css('display','none');
              $('.blurText').css('opacity',0.4);
          } else {
              dots.style.display = "none";
              btnText.innerHTML = "Read less";
              moreText.style.display = "inline";
              $("span.blurText").parents("p:first").css('display','contents');
              $('#more + p').css('display','inline-block');
              $('#more + p').css('padding-top','5px');
              $('.blurText').css('opacity',1);
          }
      });
    }

    /* Inquiry form popup open and close on arrow click */
    $('#form-btn-arrow').click(function(){
        if($(this).hasClass('close')){
            $(this).removeClass('close');
            $(this).addClass('open');
            $('.inquiry-tab-arrow > i').removeClass('down');
            $('.inquiry-tab-arrow > i').addClass('up');
            $('.inquiry-form .contact-form').css('display','block');
        }else{
            $(this).removeClass('open');
            $(this).addClass('close');
            $('.inquiry-form .contact-form').css('display','none');
            $('.inquiry-tab-arrow > i').removeClass('up');
            $('.inquiry-tab-arrow > i').addClass('down');
        }
    });

    /* To append "Trade" title at the beginning of the image div to show in on responsive view when image goes up and caption moves down*/
    $('[id ^=shopify-section-template][id $=image_with_text_3UUaLc]').prepend("<h2 class='page-title-trade'>Trade</h2>");

    /* breadcrumb if all inner sub-nav have child, then to reset one to has-no-nav-chils to avoid design disturbance related to border highlight*/
    setTimeout(function() {
        // Code to be executed after the delay to set the newclass to .has-inner-nav-childs li when subordinate parent li too has sub-nav-categories
        if($("ul.fn-main-navigation").find(".level2.subnav.innernav-li.has-inner-nav-childs.active.selected").length !== 0){
          $("li.level2.subnav.innernav-li.has-no-nav-childs.selected").addClass("removeAfterContent");
      }
    }, 30);

    /* read-more - visit page listing : start */
    var btnappletext = $('[id ^=shopify-section-template][id $=image_banner_bLbbgr] .button.button--primary:nth-of-type(1)').text();
    var btnspotifytext = $('[id ^=shopify-section-template][id $=image_banner_bLbbgr] .button.button--primary:nth-of-type(2)').text();
    var btnappleLink = $('[id ^=shopify-section-template][id $=image_banner_bLbbgr] .button.button--primary:nth-of-type(1)').attr('href');
    var btnspotifyLink = $('[id ^=shopify-section-template][id $=image_banner_bLbbgr] .button.button--primary:nth-of-type(2)').attr('href');
  
    $('.visit .banner__buttons.banner__buttons--multiple')
      .html('<div class="banner__buttons banner__buttons--multiple"><div class="fn-icon-1"><i class="fa-brands fa-apple" aria-hidden="true"></i><a target="_blank" href="'+btnappleLink+'" role="link" aria-disabled="true" class="button button--primary">'+btnappletext+'</a></div><div class="fn-icon-1"><i class="fa-brands fa-spotify" aria-hidden="true"></i><a href="'+btnspotifyLink+'" target="_blank" role="link" aria-disabled="true" class="button button--primary">'+btnspotifytext+'</a></div></div>');
    $('#listen-btn-read-more').click(function(){
        if($(this).hasClass('close')){
            $(this).removeClass('close');
            $(this).addClass('open');
            $('.show-more-list').css('display','block');
            $('#listen-btn-read-more span').html('View less');
        }else{
            $(this).removeClass('open');
            $(this).addClass('close');
            $('.show-more-list').css('display','none');
            $('#listen-btn-read-more span').html('View more');
        }
    });
    /* read-more - visit page listing : end */

    /* visit sections scroll : start */  
    $('[id ^=shopify-section-template][id $=rich_text_Jm4jNj] .rich-text__blocks.left').append('<a href="#listen-title" class="scroll-listen"><span class="listen">Listen</span></a><a href="#visit-title" class="scroll-location"><span class="location">Location</span></a>');
    /* visit sections scroll : end */

    /* Product detailed page shipping. description, sizechart accordian click trigger : start */  
    function productDescriptionShippingTab(button){
        if($(button).find('p > span').hasClass('plus')){
            $('#product-detailed-page .section-product-details-custom-tabs').find('.section-title > p > span').html('+');
            $('#product-detailed-page .section-product-details-custom-tabs').find('.section-title > p > span').removeClass('minus');
            $('#product-detailed-page .section-product-details-custom-tabs').find('.section-title > p > span').addClass('plus');
            $('#product-detailed-page .section-product-details-custom-tabs').find('.section-details').css('display', 'none');
          
            $(button).find('.section-title > p > span').html('-');
            $(button).find('.section-title > p > span').removeClass('plus');
            $(button).find('.section-title > p > span').addClass('minus');
            $(button).find('.section-details').css('display', 'block');
        }else{
            $(button).find('.section-title > p > span').html('+');
            $(button).find('.section-title > p > span').removeClass('minus');
            $(button).find('.section-title > p > span').addClass('plus');
            $(button).find('.section-details').css('display', 'none');
        }
    }  
    $('#product-detailed-page .section-product-details-custom-tabs .description-tab').click(function(){
        productDescriptionShippingTab(this);
    });
    $('#product-detailed-page .section-product-details-custom-tabs .shipping-tab').click(function(){
        productDescriptionShippingTab(this);
    });
    $('#product-detailed-page .section-product-details-custom-tabs .size-chart-tab').click(function(){
        productDescriptionShippingTab(this);
    });    
    /* Product detailed page shipping. description, sizechart accordian click trigger : end */  

    /* To keep enquiry form form if have any validation errors : start */
    if( $('#product-inquiry-form .contact-form .form__message').length ){
        $('#form-btn-arrow').click();
    }
    /* To keep enquiry form form if have any validation errors : end */    

    $("#product-detailed-page .toggle-lightbox").click(function(e){
       $(this).find(".lightbox").toggle();
       e.preventDefault();
       e.stopPropagation();
       return false;
   });

  /* Homepage promo section : start */
  var promobtnImagelink = $.trim($('[id ^=ImageWithText--template][id $=image_with_text_cWNNNE] a').text());
  if(promobtnImagelink){
      $('[id ^=ImageWithText--template][id $=image_with_text_cWNNNE] a').html('<img class="promo-image-home" src="'+promobtnImagelink+'" />');
      $('[id ^=ImageWithText--template][id $=image_with_text_cWNNNE] a').css('display','block');
  }   
  var promoImagelink = $('[id ^=ImageWithText--template][id $=image_with_text_cWNNNE] a').attr('href');
  if(promoImagelink == undefined){
      promoImagelink = 'javascript:void(0)';
  }
  var sectionImagehHtml = $('[id ^=shopify-section-template][id $=image_with_text_cWNNNE] .image-with-text__media').html();
  $('[id ^=shopify-section-template][id $=image_with_text_cWNNNE] .image-with-text__media').html('<a href="'+promoImagelink+'">'+sectionImagehHtml+'</a>');
  /* Homepage promo section : end */

  /* header overlap when menu is open in mobile */
  $('#Details-menu-drawer-container > .header__icon--summary').click(function(){
    if( $('#Details-menu-drawer-container > .header__icon--summary').attr('aria-expanded') == 'true' ){
      $('.breadcrumb.fn-bredcrumb').css('z-index','unset');
      $('.breadcrumb.fn-bredcrumb').css('position','unset');
    }else{      
      $('.breadcrumb.fn-bredcrumb').css('z-index','100');
      $('.breadcrumb.fn-bredcrumb').css('position','fixed');
    }
  });

  /* header overlap when searched */
  $('.header__search').click(function(){
    console.log($('.header__search > details').attr('open'));
    if( $('.header__search > details').attr('open') == 'open' ){
      $('.breadcrumb.fn-bredcrumb').css('z-index','unset');
      $('.breadcrumb.fn-bredcrumb').css('position','unset');
    }else{      
      $('.breadcrumb.fn-bredcrumb').css('z-index','100');
      $('.breadcrumb.fn-bredcrumb').css('position','fixed');
    }
  });

  /* holiday home page section : start */
  var barwareImageSrc = $.trim($('[id ^=shopify-section-template][id $=image_with_text_F63Hhm] img').attr('src'));
if(barwareImageSrc){
  // First, hide the original image
  $('[id ^=shopify-section-template][id $=image_with_text_F63Hhm] img').css('display', 'none');
  
  // Remove any padding above the text element
  $('[id ^=shopify-section-template][id $=image_with_text_F63Hhm] .image-with-text__text').css({
    'padding-top': '0',
    'margin-top': '0'
  });
  
  // Insert the image into the text paragraph
  $('[id ^=shopify-section-template][id $=image_with_text_F63Hhm] p.image-with-text__text').html('<img class="barware-right-image" src="'+barwareImageSrc+'" />');
  
  // Make sure the inserted image also has no top padding
  $('[id ^=shopify-section-template][id $=image_with_text_F63Hhm] .barware-right-image').css({
    'padding-top': '0',
    'margin-top': '0'
  });
}  
  var tabletopUrl = window.location.origin+'/collections/tabletop';
  var decorUrl = window.location.origin+'/collections/decor';
  $('[id ^=Banner-template][id $=image_banner_G9nENA] div.banner__media.media.banner__media-half:nth-child(1) img').after('<div class="overlay shop-text-holiday-banner-left"><div class="image-text-section-left"><h2 class="text">Tabletop</h2><a class="text" href="'+tabletopUrl+'">shop now</a></div></div>');
  $('[id ^=Banner-template][id $=image_banner_G9nENA] div.banner__media.media.banner__media-half:nth-child(2) img').after('<div class="overlay shop-text-holiday-banner-right"><div class="image-text-section-right"><h2 class="text">Decor</h2><a class="text" href="'+decorUrl+'">shop now</a></div></div>');  
  $('[id ^=Banner-template][id $=image_banner_G9nENA] div.banner__content.banner__content--middle-center.page-width').remove();
  
  /* holiday home other sections */
  var gardenUrl = window.location.origin+'/collections/garden';
  var tabletopUrl = window.location.origin+'/collections/tabletop';
  $('[id ^=Banner-template][id $=image_banner_KGMgGq]').attr('style', 'padding-top: 20px !important');
  $('[id ^=Banner-template][id $=image_banner_KGMgGq]').parent().attr('style', 'padding-top: 20px !important');
  $('[id ^=Banner-template][id $=image_banner_KGMgGq] div.banner__media.media.banner__media-half:nth-child(1) img').after('<div class="overlay shop-text-holiday-banner-left"><div class="image-text-section-left"><h2 class="text" >garden</h2><a class="text" href="'+gardenUrl+'">shop now</a></div></div>');
  $('[id ^=Banner-template][id $=image_banner_KGMgGq] div.banner__media.media.banner__media-half:nth-child(2) img').after('<div class="overlay shop-text-holiday-banner-right"><div class="image-text-section-right"><h2 class="text">tabletop</h2><a class="text" href="'+tabletopUrl+'">shop now</a></div></div>');    
  $('[id ^=Banner-template][id $=image_banner_KGMgGq] div.banner__content.banner__content--middle-center.page-width').remove();
  /* holiday home other sections */

  /* To switch barware sections : start */
  var barwarebannerSection = $('[id ^=shopify-section-template][id $=image_with_text_DfEGEh]').html();
  $('<div id="shopify-section-template-image_with_text_DfEGEh" class="shopify-section section barware-mobile-section">'+barwarebannerSection+'</div>').insertAfter($('[id ^=shopify-section-template][id $=image_with_text_F63Hhm]'));  
  /* To switch barware sections : end */
  
});
 